module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICA8cGF0aCBmaWxsPSIjNEZBNDQ0IiBkPSJNNS4wNjYgMTMuNTM1YTEuMTAyIDEuMTAyIDAgMCAxLS4xMDIuMDc3bC0zLjI2MyAyLjIwMWExLjA5IDEuMDkgMCAxIDEtMS4yMi0xLjgwOGwzLjI1NS0yLjE5NmE2LjY1OCA2LjY1OCAwIDEgMSAxLjMzIDEuNzI1em0zLjY4Mi0uNDgxYTQuNDc3IDQuNDc3IDAgMSAwIDEuNzA4LTguNzg5IDQuNDc3IDQuNDc3IDAgMCAwLTEuNzA4IDguNzg5eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-search.svg
// module id = 278
// module chunks = 0